document.addEventListener('DOMContentLoaded', function () {
  // Initialize carousel scroll logic

  console.log("AAAA");
  const carousel = document.querySelector('.collection-links__carousel');
  console.log("AAAA LOADED");

  if (!carousel) return;
  const carouselViewport = carousel?.querySelector('.carousel__viewport');
  if (!carouselViewport) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  carouselViewport.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - carouselViewport.offsetLeft;
    scrollLeft = carouselViewport.scrollLeft;
  });

  carouselViewport.addEventListener('mouseleave', () => {
    isDown = false;
  });

  carouselViewport.addEventListener('mouseup', () => {
    isDown = false;
  });

  carouselViewport.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - carouselViewport.offsetLeft;
    const walk = (x - startX) * 3; // Adjust the speed
    carouselViewport.scrollLeft = scrollLeft - walk;
  });

  // Handle touch events
  carouselViewport.addEventListener('touchstart', (e) => {
    isDown = true;
    startX = e.touches[0].clientX - carouselViewport.offsetLeft;
    scrollLeft = carouselViewport.scrollLeft;
  });

  carouselViewport.addEventListener('touchend', () => {
    isDown = false;
  });

  carouselViewport.addEventListener('touchmove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.touches[0].clientX - carouselViewport.offsetLeft;
    const walk = (x - startX) * 3; // Adjust the speed
    carouselViewport.scrollLeft = scrollLeft - walk;
  });

  // Tab handling logic
  const tabs = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (item) {
        item.classList.remove('active');
      });
      tabContents.forEach(function (item) {
        item.classList.remove('active');
      });

      tab.classList.add('active');
      const tabId = tab.getAttribute('data-tab');
      const activeTabContent = document.getElementById(tabId);
      activeTabContent.classList.add('active');

      // Check arrows - Determine the number of slides within the currently active tab
      updateCarouselButtonsVisibility(activeTabContent);
    });
  });

  if (tabs.length > 0) {
    tabs[0].classList.add('active');
    tabContents[0].classList.add('active');
    // Check arrows for the first tab when the page loads
    updateCarouselButtonsVisibility(tabContents[0]);
  }

  // Function to hide/show arrows
  function updateCarouselButtonsVisibility(activeTabContent) {
    const slides = activeTabContent.querySelectorAll('.carousel__slide-quick_links');
    const prevButton = activeTabContent.querySelector('.collection-links__carousel-btn--prev');
    const nextButton = activeTabContent.querySelector('.collection-links__carousel-btn--next');

    if (slides.length <= 5) {
      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
    } else {
      if (prevButton) prevButton.style.display = '';
      if (nextButton) nextButton.style.display = '';
    }
  }
});
